import React from "react";
import "./style.css";
import CustomCard from "../CustomCard";
import { useSelector } from "react-redux";
import { dentalIcons } from "../../../utils-icons/dentalIcons";
import { renderToothConditionColors } from "../../../../helper";
import aboutUsIcon from "../../../../assets/dental-inden/icons/aboutUsIcon.svg";

const Quadrant = ({
  isStart = false,
  title,
  onClick,
  identifier,
  onContextClick,
}) => {
  const quadrantData = useSelector((state) => state.dental?.quadrants || []);
  const tempTeeth = useSelector((state) => state.dental?.tempTeeth || []);
  const tetempQuadrantmpTeeth = useSelector(
    (state) => state.dental?.tempQuadrant || []
  );

  const currentQuadrant = quadrantData?.find(
    (quadrant) => quadrant.quadrant === identifier
  );

  return (
    <div className="d_quadrant_container" onClick={onClick}>
      <div
        className="d_quadrant_body"
        style={{
          justifyContent: isStart ? "flex-start" : "flex-end",
          background: tetempQuadrantmpTeeth?.includes(identifier)
            ? "#20C3FF2E"
            : "white",
          cursor: tempTeeth.length > 0 ? "no-drop" : "pointer",
        }}
        onContextMenu={(e) => onContextClick(e, currentQuadrant, "quadrant")}
      >
        <p>{title}</p>
        <div className="d_quadrant_conditions">
          {currentQuadrant?.marked_completed && (
            <img
              src={dentalIcons.dentalRecordAdded}
              className="d_quadrant_conditions_icon"
            />
          )}
          {currentQuadrant?.observation?.trim() && (
            <img
              src={aboutUsIcon}
              className="d_quadrant_observation_icon"
              style={{ height: 12 }}
            />
          )}
          {currentQuadrant?.conditions?.map((el, index) => (
            <span
              key={index}
              style={{
                color: renderToothConditionColors(el.condition_type),
              }}
            >
              {el.condition_identifier}
              {index < currentQuadrant.conditions.length - 1 && ",  "}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Quadrant;
